<template>
  <div class="wages wrapper shadow level-setting">
    <div class="operation">
      <div class="left">
        <div class="main-title">岗位级别设置</div>
      </div>
    </div>
    <el-tabs v-model="activeName" class="main-tabs" @tab-change="tabChange">
      <el-tab-pane label="员工级别设置" name="T"></el-tab-pane>
      <el-tab-pane label="管理层级别设置" name="M"></el-tab-pane>
      <el-tab-pane label="试用期层级别设置" name="S"></el-tab-pane>
        <el-tab-pane label="特殊级别设置" name="X"></el-tab-pane>
    </el-tabs>
    <div class="level-pane">
      <ul>
        <li v-for="(item, index) in levelList
                        .filter(e=>e.type == levelName)
                        .sort((a, b) => Number(a.name.substring(1)) - Number(b.name.substring(1)))" :key="index">
            <div v-if="levelName != 'X'" class="name">
                级别：<span>{{ item.name }}</span>
            </div>
            <div v-else class="name">
                <el-input
                    v-model="item.name"
                    placeholder="请输入级别名称"
                    size="large"
                ></el-input>
            </div>
          <div class="base-pay">
            <span>基本工资：</span
            ><el-input
              v-model="item.baseSalary"
              placeholder="基本工资"
              size="large"
              type="number"
            >
              <template #prepend>￥</template>
            </el-input>
            <el-button
                v-if="index >= levelList.filter(e=>e.type == levelName).length-1"
              class="del-btn"
              type="danger"
              :icon="Delete"
              @click="delClick(item.id)"
            ></el-button>
          </div>
        </li>
      </ul>
      <div class="operate-btn">
        <el-button
          type="warning"
          @click="addClick"
          class="main-btn main-btn-warning add-btn"
          >添加级别</el-button
        >
        <el-button
          type="primary"
          @click="saveClick"
          class="main-btn main-btn-primary save-btn"
          >保存设置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { Delete } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {batchSave, fetchList} from "@/api/jobLevel";

const activeName = ref("T");
const levelName = ref("T");

const tabChange = (name) => {
    levelName.value = name;
};
onMounted(() => {
  levelName.value = "T";
  getList();
});

const levelList = ref([]);

const getList = () => {
    fetchList().then((res) => {
        levelList.value = res.data.list
    });
}

// 添加一行
const addClick = () => {
    let no = levelList.value.filter(e => e.type == levelName.value).length + 1
    if(levelName.value == 'X') no = ''
    levelList.value.push({
        id: '',
        type: levelName.value,
        name: levelName.value + no,
        baseSalary: '',
    });
};
// 删除一行
const delClick = (id) => {
    let index = levelList.value.findIndex(e => e.id == id)
    levelList.value.splice(index, 1);
};
// 保存设置
const saveClick = () => {
    let list = levelList.value.filter(e => e.type == levelName.value)
    list.forEach(e => {
        if (!e.baseSalary) {
            e.baseSalary = 0
        }
    })
  ElMessageBox.confirm("确定要保存设置吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        batchSave({ list: levelList.value, type: levelName.value }).then(() => {
            getList()
            ElMessage({
                type: "success",
                message: "保存成功！",
            });
        })
    })
    .catch(() => {});
};
</script>

<style lang="scss" scoped>
.level-setting {
  .level-pane {
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #e0f2ff;
        padding: 5px 10px;
        margin: 0 0 10px 0;
        .name {
          span {
            font-size: 18px;
            font-weight: bold;
            color: $main-color;
          }
        }
        .base-pay {
          display: flex;
          align-items: center;
          span {
            white-space: nowrap;
          }
          ::v-deep .el-input {
            .el-input__inner {
              font-size: 18px;
              font-weight: bold;
              color: $main-color;
              &::placeholder {
                font-size: 14px;
                font-weight: normal;
              }
            }
          }
          .del-btn {
            margin: 0 0 0 10px;
            padding: 8px 10px;
            font-size: 18px;
          }
        }
      }
    }
  }
  .operate-btn {
    margin: 10vh auto 0;
    width: fit-content;
    .save-btn {
      width: 240px;
    }
  }
}
@media (max-width:1200px) {
		.level-pane{
			li{
				width: 100%!important;
			}
		}
	}
</style>
